<template>
	<swiper class="knd-swiper" :options="swiperOption" >
		<swiper-slide v-for="(item, index) in data" :key="'swiper' + index">
			<div class='swiper--content'>


				<div class='knd--swiper-title m-b-small'>
					{{item.Arrestatieplaats}}
				</div>

				<div class='knd-table--title'>Arrestaties</div>
				<table class="knd-table m-b-medium">
					<thead>
						<th class="">Sinti en Roma</th> 
						<th class="">Woonwagenbewoners</th> 
					</thead>
						<tr>
							<td class="">{{item['Sinti/Roma (gemengd)'] || 0}}</td> 
							<td class="">{{item['Woonwagenbewoners'] || 0}}</td> 
					</tr>
				</table>


				<div class='knd--swiper-content'>
					{{item.Tooltip}}
				</div>
			</div>
		</swiper-slide>
		<div class="swiper-pagination" slot="pagination"></div>
		<div class="swiper-button-prev" slot="button-prev"></div>
		<div class="swiper-button-next" slot="button-next"></div>
	</swiper>
</template>

<script>
/* eslint-disable */ 

	import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
	import 'swiper/css/swiper.css'

	export default {
		name: 'swiper-example-pagination-fraction',
		title: 'Fraction pagination',
		props: ['index'],
		components: {
			Swiper,
			SwiperSlide
		},
    watch: { 
			index: function(newVal, oldVal) { // watch it
        this.swiper.slideTo(newVal + 1, 0);
      }
    },
    mounted: function() {
			this.swiper = document.querySelector('.knd-swiper').swiper;
    },
		data() {
			return {
				data: this.$store.state.data,
				swiperOption: {
					pagination: {
						el: '.swiper-pagination',
						type: 'fraction'
					},
					loop: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				}
			}
		}
	}
</script>